class AdaptiveProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.sliderEl = null;
    this.swiperPollId = null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.sliderEl = this.querySelector('.adaptive-product-slider__slider');
    const wrapper = this.querySelector('.js-adaptive-product-slider');
    if (!this.sliderEl || !wrapper) return;

    this.waitForSwiper();
  }

  disconnectedCallback() {
    if (this.swiperPollId) {
      clearInterval(this.swiperPollId);
      this.swiperPollId = null;
    }
    this.destroySwiper();
  }

  waitForSwiper() {
    if (typeof window.Swiper === 'function') {
      this.initSwiper();
      return;
    }

    let attempts = 0;
    this.swiperPollId = setInterval(() => {
      attempts += 1;
      if (typeof window.Swiper === 'function') {
        clearInterval(this.swiperPollId);
        this.swiperPollId = null;
        this.initSwiper();
      } else if (attempts >= 100) {
        clearInterval(this.swiperPollId);
        this.swiperPollId = null;
      }
    }, 50);
  }

  initSwiper() {
    if (this.swiper || !this.sliderEl) return;

    const prevBtn = this.querySelector('.adaptive-product-slider__nav--prev');
    const nextBtn = this.querySelector('.adaptive-product-slider__nav--next');

    this.swiper = new window.Swiper(this.sliderEl, {
      wrapperClass: 'js-adaptive-product-slider',
      slideClass: 'item',
      slidesPerView: 'auto',
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      speed: 400,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        1024: { slidesPerView: 3, slidesOffsetBefore: 48 },
        1440: { slidesPerView: 4, slidesOffsetBefore: 48 }
      },
      navigation:
        prevBtn && nextBtn
          ? {
              prevEl: prevBtn,
              nextEl: nextBtn,
              disabledClass: 'swiper-button-disabled'
            }
          : false,
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous',
        nextSlideMessage: 'Next'
      },
      on: {
        init: swiper => {
          swiper.el.classList.add('swiper-initialized');
        }
      }
    });
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('adaptive-product-slider')) {
  customElements.define('adaptive-product-slider', AdaptiveProductSlider);
}
